import React from 'react';
import PropTypes from 'prop-types';
import { ApexSuccess as ApexSuccess$1 } from '@zillow/zrs-cms';
import { generateBlockList } from '../components/BlockList/BlockList.js';

var BlockApexSuccess = function BlockApexSuccess(_ref) {
  var index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  return /*#__PURE__*/React.createElement(ApexSuccess$1, {
    key: index
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
BlockApexSuccess.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number
} : {};
var ApexSuccess = BlockApexSuccess;

export { ApexSuccess as default };
